const mediaUtils = {
  methods: {
    getMediumById (mediumId) {
      return this.$store.state.Medium.media_list.find(medium => medium.id === mediumId)
    },
    getMediumThumbnailPath (medium) {
      if (!medium) return
      if (medium.Medium && medium.Medium.type === 'Audio') {
        return 'static/audio.svg'
      }
      if (medium.Medium && medium.Medium.type === 'HTML5app') {
        return 'static/HTML5app.svg'
      }
      if (medium.Medium && medium.Medium.type === 'HTMLzip') {
        return 'static/HTMLzip.svg'
      }
      if (medium.Medium && medium.Medium.type === 'Custom') {
        return 'static/FileCustom.svg'
      }
      if (!medium || !medium.File) {
        return 'static/none2.png'
      }
      return this.getThumbnailPath(medium.File)
    },
    toggleMediumInSelectedMedia (medium, $event, media = [], callingComponent = 'Library') {
      if (medium.type === 'PlayListLibraryRoot') return
      if (!$event.shiftKey) {
        if (!$event.ctrlKey && !$event.metaKey) {
          this.$store.dispatch('Medium/clearMediaSelectedLeft')
          this.$store.dispatch('Medium/addMediumSelectedLeft', medium)
          return
        }
        this.$store.dispatch('Medium/toggleMediumSelectedLeft', medium)
      }
      if ($event.shiftKey) {
        const previouslySelectedMediumIndex = callingComponent === 'Library'
          ? media.findIndex(f => f.Medium.id === this.$store.state.Medium.media_selected_left[this.$store.state.Medium.media_selected_left.length - 1].id)
          : media.findIndex(f => f.id === this.$store.state.Medium.media_selected_left[this.$store.state.Medium.media_selected_left.length - 1].id)
        const mediumClickedIndex = callingComponent === 'Library'
          ? media.findIndex(f => f.Medium.id === medium.id)
          : media.findIndex(f => f.id === medium.id)
        const startIndex = previouslySelectedMediumIndex < mediumClickedIndex ? previouslySelectedMediumIndex : mediumClickedIndex
        const endIndex = previouslySelectedMediumIndex < mediumClickedIndex ? mediumClickedIndex : previouslySelectedMediumIndex
        this.$store.dispatch('Medium/clearMediaSelectedLeft')
        if (callingComponent === 'Library') {
          for (const medium of media.slice(startIndex, endIndex + 1)) {
            this.$store.dispatch('Medium/addMediumSelectedLeft', medium.Medium)
          }
        } else {
          this.$store.dispatch('Medium/setSelectedLeft', media.slice(startIndex, endIndex + 1))
        }
      }
    },
    playListThumbnailById (mediumId) {
      let medium = this.$store.state.Medium.media_list.find(
        medium => medium.id === mediumId
      )
      if (!medium) return
      return this.getThumbnailPath(medium.File)
    },
    getThumbnailPath (file, quality) {
      if (typeof file === 'number') {
        file = this.$store.state.File.file_list.find(f => f.id === file)
      }
      if (!file || !file.originalsha256 || !file.currentsha256) return 'static/none2.png'
      if (file.originalMimeType.indexOf('audio') > -1) return 'static/audio.svg'
      return !quality || quality === 'low' ? file.thumbnailFilename : file.thumbnailFilename.replace('_thumbnail', '')
    },
    __filterByString (medium) {
      const searchString = this.$store.state.Medium.search_by_string.toLowerCase()
      return medium.name.toLowerCase().indexOf(searchString) > -1
    },
    __sortMedia (media) {
      let sortColumn
      let mediaSorted
      const mediaUnfreezed = JSON.parse(JSON.stringify(media))
      switch (this.sortColumnActive) {
        case 'Name':
          sortColumn = 'name'
          mediaSorted = mediaUnfreezed.sort((x, y) => (x[sortColumn] > y[sortColumn]) ? 1 : ((y[sortColumn] > x[sortColumn]) ? -1 : 0))
          break
        case 'Duration':
          for (const medium of mediaUnfreezed) {
            if (medium.type === 'Video') medium.duration = medium.File.originalDurationMs
            if (medium.type === 'Image') medium.duration = 5000
            if (medium.type.startsWith('PlayList')) medium.duration = medium.playListDurationMs
          }
          sortColumn = 'duration'
          mediaSorted = mediaUnfreezed.sort(function (x, y) {
            return y[sortColumn] - x[sortColumn]
          })
          break
        case 'Added':
          sortColumn = 'createdAt'
          mediaSorted = mediaUnfreezed.sort(function (x, y) {
            return y[sortColumn] - x[sortColumn]
          })
          break
        case 'Modified':
          sortColumn = 'updatedAt'
          mediaSorted = mediaUnfreezed.sort(function (x, y) {
            return y[sortColumn] - x[sortColumn]
          })
          break
        default:
          sortColumn = this.sortColumnActive
          mediaSorted = mediaUnfreezed.sort(function (x, y) {
            return y[sortColumn] - x[sortColumn]
          })
          break
      }
      return mediaSorted
    },
    __sortPlayitemsByMediaPropierties (media) {
      let sortColumn
      let mediaSorted
      switch (this.sortColumnActive) {
        case 'Name':
          sortColumn = 'name'
          mediaSorted = media.sort((x, y) => (x.Medium[sortColumn] > y.Medium[sortColumn]) ? 1 : ((y.Medium[sortColumn] > x.Medium[sortColumn]) ? -1 : 0))
          // Should be better but does not work :( Why?
          // mediaSorted = media.sort(function (a, b) {
          //   return ('' + a.attr).localeCompare(b.attr)
          // })
          break
        case 'Duration':
          for (const medium of media) {
            if (medium.Medium.type === 'Video') medium.duration = medium.File.originalDurationMs
            if (medium.Medium.type === 'Image') medium.duration = 5000
            if (medium.Medium.type.startsWith('PlayList')) medium.duration = medium.Medium.playListDurationMs
          }
          sortColumn = 'duration'
          mediaSorted = media.sort(function (x, y) {
            return y[sortColumn] - x[sortColumn]
          })
          break
        case 'Added':
          sortColumn = 'createdAt'
          mediaSorted = media.sort(function (x, y) {
            return y.Medium[sortColumn] - x.Medium[sortColumn]
          })
          break
        case 'Modified':
          sortColumn = 'updatedAt'
          mediaSorted = media.sort(function (x, y) {
            return y.Medium[sortColumn] - x.Medium[sortColumn]
          })
          break
        default:
          sortColumn = this.sortColumnActive
          mediaSorted = media.sort(function (x, y) {
            return y.Medium[sortColumn] - x.Medium[sortColumn]
          })
          break
      }
      return mediaSorted
    },
    validateRestriction (restriction) {
      const now = new Date()
      if (new Date(restriction.validTo) < now) {
        return 'past'
      }
      if (new Date(restriction.validFrom) > now) {
        return 'future'
      }
      if (new Date(restriction.validFrom) < now && new Date(restriction.validTo) > now) {
        return 'current'
      }
    },
    itemWillNeverBePlayed (item) {
      let playDueToDaytime = false
      // has no restriction, will play always
      if (item.PlayListItem_DaytimeRestrictions.length === 0) playDueToDaytime = true
      // has a restriction with no ending date,
      // or has a restriction with ending date in future,
      // is playing or will play some day
      if (item.PlayListItem_DaytimeRestrictions.find(pdtr => !pdtr.validTo || new Date(pdtr.validTo) > new Date())) playDueToDaytime = true

      let playDueToDate = false
      // we have no date restriction, play always allowed
      if (item.PlayListItem_DateRestrictions.length === 0) playDueToDate = true
      // we have some date restriction in future, will play some dates
      if (item.PlayListItem_DateRestrictions.find(pdr => !pdr.lastPlayDate || (new Date(pdr.lastPlayDate) > new Date()))) playDueToDate = true
      return !playDueToDaytime || !playDueToDate
    },
    // CHECK IF PLAYITEM HAS RESTRICTIONS
    itemHasDayTimeRestrictions (item) {
      return (item.PlayListItem_DaytimeRestrictions && item.PlayListItem_DaytimeRestrictions.length > 0)
    },
    itemHasDateRestrictions (item) {
      return (item.PlayListItem_DateRestrictions && item.PlayListItem_DateRestrictions.length > 0)
    },
    itemHasHolidayRestrictions (item) {
      return (item.HolidaySets && item.HolidaySets.length > 0)
    },
    itemHasZoneRestrictions (item) {
      return (item.width !== 1920 && item.width !== 0) || (item.height !== 1080 && item.height !== 0) || item.anchorX !== 0 || item.anchorY !== 0
    },
    itemHasPlayRestrictions (item) {
      return item.playDurationMs > 0 || item.playOffsetMs !== 0 || item.objectFit !== 'default'
    },
    itemHasTimeRestrictions (item) {
      return this.itemHasDateRestrictions(item) ||
       this.itemHasDayTimeRestrictions(item) ||
       this.itemHasHolidayRestrictions(item)
    },
    itemHasSynchroRestrictions (item) {
      return item.broadcastSynchronize || item.listenSynchronize
    },
    itemHasPlayerExeptions (item) {
      if (!item.playForbiddenInMedia && !item.playOnlyInMedia) return false
      if (item.playForbiddenInMedia && JSON.parse(item.playForbiddenInMedia).length > 0) return true
      if (item.playOnlyInMedia && JSON.parse(item.playOnlyInMedia).length > 0) return true
      return false
    }
  },
  computed: {
    canReplaceMediumInNetwork () {
      const canReplaceMediumInNetwork = this.$store.state.Medium.media_selected_left.length === 1 &&
        this.$store.state.Medium.playitems_selected_right.length === 1 &&
        // FIXME - temporary loop prevention - make replace not available for playlists
        this.$store.state.Medium.playitems_selected_right[0].Medium.type.indexOf('PlayList') === -1 &&
        this.$store.state.Medium.media_selected_left[0].type.indexOf('PlayList') === -1 &&
        this.$store.state.Medium.media_selected_left[0].id !== this.$store.state.Medium.playitems_selected_right[0].Medium.id &&
        this.panelOpenRight === 'media'
      return canReplaceMediumInNetwork
    },
    canReplaceMediumInPlaylist () {
      const canReplaceMediumInPlaylist = this.$store.state.Medium.media_selected_right.length === 1 &&
        this.$store.state.Medium.media_selected_right[0].type.indexOf('PlayList') > -1 &&
        this.$store.state.Medium.playitems_selected_right.length === 1 &&
        // FIXME - temporary loop prevention - make replace not available for playlists
        // this.$store.state.Medium.media_selected_left[0].type.indexOf('PlayList') === -1 &&
        this.$store.state.Medium.media_selected_left[0].id !== this.$store.state.Medium.media_selected_right[0].id &&
        this.panelOpenRight === 'media'
      return canReplaceMediumInPlaylist
    },
    assignTargetsSelectedRight () {
      let someNonTargetMediaSelectedRight = false
      for (const medium of this.$store.state.Medium.media_selected_right) {
        if (!medium || !medium.type.startsWith('PlayList')) {
          someNonTargetMediaSelectedRight = true
          continue
        }
      }
      if (
        this.$store.state.User.rightPanelChosen === 'media' &&
        (someNonTargetMediaSelectedRight || this.$store.state.Medium.media_selected_right.length === 0)
      ) return false

      if (
        this.$store.state.User.rightPanelChosen === 'devices' &&
        !this.someDesktopTargetsSelectedRight
      ) return false
      return true
    },
    panelOpenRight () {
      return this.$store.state.User.rightPanelChosen
    },
    assignableMediaSelectedLeft () {
      return this.$store.state.Medium.media_selected_left.length > 0
    },
    someDesktopTargetsSelectedRight () {
      if (this.$store.state.Device.desktops_selected_right.length === 0) return false
      return true
    },
    someTagsInClipboard () {
      return this.$store.state.Clipboard.copied_media_tags.length > 0
    },
    someNonPlaylistMediaSelectedLeft () {
      return this.$store.state.Medium.media_selected_left.filter(m => !m.type.startsWith('PlayList')).length > 0
    }
  }
}
export default mediaUtils



// WEBPACK FOOTER //
// ./src/components/Common/mediaUtils.mixin.js